$(function () {
  // Preload icons
  const ICONS = {
    YES: `
      <svg width="484" height="561" viewBox="0 0 484 561" xmlns="http://www.w3.org/2000/svg">
        <path d="M459.16 34.223C418.715 22.399 332.85 0 242 0C151.15 0 65.29 22.398 24.84 34.223C10.528 38.5785 0.574005 51.645 0.574005 67.2V371.47C0.574005 381.427 4.92951 390.759 11.773 398.224C73.996 459.201 153.023 523.914 241.993 560.004C330.97 523.914 409.993 459.204 472.213 398.224C479.057 391.38 483.412 382.044 483.412 371.47V67.2C483.412 52.266 473.455 38.579 459.146 34.223H459.16ZM440.492 368.973C369.558 437.418 304.852 484.703 242.002 512.703C179.158 484.082 114.452 436.793 43.512 368.973V74.043C85.821 61.602 162.352 43.555 242.002 43.555C321.652 43.555 398.182 61.598 440.492 74.043V368.973Z" fill="black"/>
        <path d="M223.96 363.38L132.491 273.157L161.112 244.536L220.225 303.024L332.225 163.024L363.959 187.911L223.96 363.38Z" fill="black"/>
      </svg>
    `,
    NO: `
      <svg width="484" height="561" viewBox="0 0 484 561" xmlns="http://www.w3.org/2000/svg">
        <path d="M459.16 34.223C418.715 22.399 332.85 0 242 0C151.15 0 65.29 22.398 24.84 34.223C10.528 38.5785 0.574005 51.645 0.574005 67.2V371.47C0.574005 381.427 4.92951 390.759 11.773 398.224C73.996 459.201 153.023 523.914 241.993 560.004C330.97 523.914 409.993 459.204 472.213 398.224C479.057 391.38 483.412 382.044 483.412 371.47V67.2C483.412 52.266 473.455 38.579 459.146 34.223H459.16ZM440.492 368.973C369.558 437.418 304.852 484.703 242.002 512.703C179.158 484.082 114.452 436.793 43.512 368.973V74.043C85.821 61.602 162.352 43.555 242.002 43.555C321.652 43.555 398.182 61.598 440.492 74.043V368.973Z" fill="black"/>
        <path d="M342.8 336.62L313.554 364.62L241.999 290.577L170.444 364.62L141.198 336.62L213.999 261.331L141.198 186.042L170.444 158.042L241.999 232.089L313.554 158.042L342.8 186.042L269.999 261.331L342.8 336.62Z" fill="black"/>
      </svg>
    `,
  };

  // Preload images
  let images;
  const elem = document.getElementById("idash-assets");
  if (elem) images = JSON.parse(elem.innerHTML || "{}");

  // iDash flow schema
  const data = [
    {
      id: "is-this-first-idash",
      title: "Is This Your First iDash?",
      options: [
        {
          title: "Yes, this is my 1st iDash",
          action: { next: "how-will-you-connect" },
          icon: ICONS.YES,
        },
        {
          title: "No, I want to connect to another iDash",
          action: { next: "66762-66562-record" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "how-will-you-connect",
      title: "How will you connect to your vehicle?",
      options: [
        {
          title: "I will use iDash as a stand-alone device",
          action: { next: "66760-66560-record" },
          image: images.obd_2,
        },
        {
          title: "I already have a PedalMonster",
          action: { next: "66569-66568-record" },
          image: images.pedalmonster,
        },
        {
          title: "I already have a Derringer",
          action: { next: "66561-66751-record" },
          image: images.derringer,
        },
        {
          title: "I already have a Six-Gun, Economind or SpeedBrake",
          action: { next: "what-is-vehicle" },
          image: images.six_gun,
        },
        {
          title: "My vehicle doesn’t have OBD, 12-volt only",
          action: { next: "66763-66563-record" },
          image: images.pre_obd,
        },
      ],
    },
    {
      id: "what-is-vehicle",
      title: "What is your vehicle?",
      options: [
        {
          title: "Chevy/GM 6.6L Duramax 2001-2010",
          action: { next: "61471-61401-record" },
          image: images.chevy_gm_66,
        },
        {
          title: "Dodge Ram 5.9L Cummins 2006-2007",
          action: { next: "61472-61402-record" },
          image: images.dodge_ram_59_0607,
        },
        {
          title: "Ford 6.4L Power Stroke 2008-2010",
          action: { next: "61472-61402-record" },
          image: images.ford_64_power_stroke,
        },
        {
          title: "Dodge Ram 5.9L Cummins 2003-2005",
          action: { next: "61473-61403-record" },
          image: images.dodge_ram_59_0305,
        },
        {
          title: "Ford 6.0L Power Stroke 2003-2007",
          action: { next: "61474-61404-record" },
          image: images.ford_60_power_stroke,
        },
        {
          title: "Cummins Class A Motorhome 2003-2012",
          action: { next: "61483-61423-record" },
          image: images.cummins_class_a_motorhome,
        },
      ],
    },
    {
      id: "66569-66568-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-66569-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-66568-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "66561-66751-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          //action: { product: "electronic-gauge-66561-all-2008-obdii-can-bus-vehicles" },
          action: { product: "data-logger-gauge-66761-derringer-tuner" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          //action: { product: "data-logger-gauge-66761-derringer-tuner" },
          action: { product: "electronic-gauge-66561-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "61471-61401-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-61471-2001-2010-chevy-gmc-2500-3500-6-6l-duramax" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-61401-2001-2010-chevy-gmc-6-6l-duramax-lb7-lly-lbz-lmm" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "61472-61402-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: {
            product: "data-logger-gauge-61472-2006-2010-dodge-ram-5-9l-cummins-2008-2010-ford-6-4l-power-stroke",
          },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: {
            product: "electronic-gauge-61402-2006-2010-dodge-ram-5-9l-cummins-2008-2010-ford-6-4l-power-stroke",
          },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "61473-61403-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-61473-2003-2005-dodge-5-9l-cummins" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-61403-2003-2005-dodge-5-9l-cummins" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "61474-61404-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-61474-2003-2007-ford-6-0l-power-stroke" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-61404-2003-2007-ford-6-0l-power-stroke" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "61483-61423-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-61483-2003-2012-class-a-motorhome-5-9l-6-7l-cummins" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-61423-2003-2012-class-a-motorhome-5-9l-6-7l-cummins" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "66760-66560-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-66760-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-66560-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "66763-66563-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-66763-vehicles-without-obd" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-66563-vehicles-without-obd" },
          icon: ICONS.NO,
        },
      ],
    },
    {
      id: "66762-66562-record",
      title: "Do you Want to Record Vehicle Data & Play it Back Later?",
      options: [
        {
          title: "Yes",
          action: { product: "data-logger-gauge-66762-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.YES,
        },
        {
          title: "No",
          action: { product: "electronic-gauge-66562-all-2008-obdii-can-bus-vehicles" },
          icon: ICONS.NO,
        },
      ],
    },
  ];
  const START_SECTION_ID = "is-this-first-idash";

  const elems = {
    container: $("[data-main-container]"),
    prevBtn: $("[data-prev-btn]"),
  };

  const history = [];

  function init() {
    render();
    attachEventHandlers();
    showSection(START_SECTION_ID);
  }

  function render() {
    data.forEach((section) => renderSection(section));
  }

  function attachEventHandlers() {
    $("[data-next-section]").each(function () {
      const nextSectionId = $(this).data("next-section");
      $(this).click(() => showSection(nextSectionId));
    });

    $("[data-idash-product-handle]").each(function () {
      const handle = $(this).data("idash-product-handle");
      $(this).click(() => {
        setIDashProduct(handle);
        window.location.href = `/products/${handle}`;
      });
    });

    elems.prevBtn.on("click", function () {
      showPrevSection();
    });
  }

  function renderSection(section) {
    const html = getSectionTemplate(section);
    elems.container.append(html);
  }

  function getSectionTemplate(section) {
    const subtitle = section.subtitle || "Pick one";
    return `
      <div 
        class="hidden ipf__section" 
        id="${section.id}"
      >
        <h1 class="ipf__title">${section.title}</h1>
        <h2 class="ipf__subtitle">${subtitle}</h2>
        <div class="ipf__radiogroup">
          ${section.options.map((option) => getOptionTemplate(section.id, option)).join("")}
        </div>
      </div>`;
  }

  function getOptionTemplate(sectionId, option) {
    const action = option.action.next
      ? `data-next-section=${option.action.next}`
      : option.action.product
      ? `data-idash-product-handle=${option.action.product}`
      : "";

    const id = `${sectionId}_${option.title}`;

    return `
      <div class="ipf__radio-wrapper">
        <input name="${sectionId}" type="radio" class="ipf__radio-input" id="${id}"/>
        <label class="ipf__radio ${option.image ? "ipf__radio--img" : ""}" ${action} for="${id}">
          ${option.image ? `<img class="ipf__option-img" src="${option.image}" loading="lazy"/>` : ""}
          ${option.icon ? `<i class="ipf__option-icon">${option.icon}</i>` : ""}
          <div class="ipf__radio-label">${option.title}</div>
        </label>
      </div>
    `;
  }

  async function showSection(sectionId) {
    const sections = $(".ipf__section");
    const sectionContainer = $(`#${sectionId}`);

    await new Promise((r) => setTimeout(r, 250));
    sections.addClass("hidden");
    sectionContainer.removeClass("hidden");

    history.push(sectionId);

    scrollToTop();

    if (history.length > 1) {
      elems.prevBtn.removeClass("hidden");
    } else {
      elems.prevBtn.addClass("hidden");
    }
  }

  function showPrevSection() {
    history.pop();
    const prevSectionId = history.pop();
    showSection(prevSectionId);
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  init();
});
